import styled from 'styled-components';

import { RadioBoxTheme } from './index';
import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface LabelProps {
	isActive: boolean;
	isDisabled?: boolean;
	theme?: RadioBoxTheme;
}

interface IconProps {
	isActive: boolean;
	theme?: RadioBoxTheme;
}

const Label = styled('label')`
	position: relative;
	display: inline-flex;
	padding-left: 25px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 20px;
	cursor: pointer;

	&:not(:last-of-type) {
		margin-right: 15px;
	}

	&:hover {
		color: ${StyleColor.Black};
	}

	color: ${({ isActive }: LabelProps) => isActive ? StyleColor.Black : StyleColor.Grey500};

	${({ isDisabled }: LabelProps) => isDisabled && `opacity: 0.5;`}

	${({ theme, isActive }: LabelProps) => theme === RadioBoxTheme.DARK && `
		color: ${isActive ? StyleColor.White : hexToRgba(StyleColor.White, 50)};

		&:hover {
			color: ${StyleColor.White};
		}
	`}

	input {
		display: none;
	}
`;

const Icon = styled('span')`
	box-sizing: border-box;
	position: absolute;
	top: 0;
	left: 0;
	width: 20px;
	height: 20px;
	border: 2px solid currentColor;
	border-radius: 50%;
	color: ${({ isActive }: IconProps) => isActive ? StyleColor.Blue300 : StyleColor.Grey500};

	${({ isActive }: IconProps) => isActive && `
		&::before {
			content: '';
			position: absolute;
			top: 4px;
			left: 4px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: currentColor;
		}
	`}

	${({ theme, isActive }: IconProps) => theme === RadioBoxTheme.DARK && `
		color: ${isActive ? NewStyleColor.Blue450 : hexToRgba(StyleColor.White, 50)};
	`}
`;

export { Label, Icon };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RadioBox/styles.ts